import React from 'react'
import { Route, Redirect } from 'react-router-dom';
import PropTypes from "prop-types";

import {  DEFAULT_REDIRECT_URL_ONCE_LOGGED_IN } from 'stores/constants';

const RoutePublic = ({ component: Component, authenticated, ...rest }) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Route {...rest} render={(props) => !authenticated ?
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Component {...props} />
        :
        <Redirect to={{ pathname:  DEFAULT_REDIRECT_URL_ONCE_LOGGED_IN, state: { from: props.location } }} />}
    />
);

RoutePublic.propTypes = {
    component: PropTypes.elementType.isRequired,
    authenticated: PropTypes.bool,
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
        hash: PropTypes.string,
        state: PropTypes.object,
        key: PropTypes.string,
    })
};

RoutePublic.defaultProps = {
    location: {
        pathname: '',
        search: '',
        hash: '',
        state: {},
        key: '',
    }
};

export default RoutePublic;